module.exports = __webpack_public_path__ + "img/banner_generic_left.623f2e31.jpg";